import { EnvironmentProviders, Provider } from '@angular/core';

import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { ReportsComponentsEffects } from './components/components.effects';
import { ReportsComponentsHttpClient } from './components/components.http-client';
import {
  ReportsComponentsNamespace,
  ReportsComponentsReducer,
} from './components/components.store';
import { reportsStoreFeatureName } from './consts';
import { ReportsDashboardsEffects } from './dashboards/dashboards.effects';
import { ReportsDashboardsHttpClient } from './dashboards/dashboards.http-client';
import {
  ReportsDashboardsNamespace,
  ReportsDashboardsReducer,
} from './dashboards/dashboards.store';
import { referenceReducer } from './meta-reducer';
import { ReportsMetricsEffects } from './metrics/metrics.effects';
import { ReportsMetricsHttpClient } from './metrics/metrics.http-client';
import { ReportsMetricsNamespace, ReportsMetricsReducer } from './metrics/metrics.store';
import { ReportsResultsEffects } from './results/results.effects';
import { ReportsResultsHttpClient } from './results/results.http-client';
import { ReportsResultsNamespace, ReportsResultsReducer } from './results/results.store';

const reportsState = provideState(
  reportsStoreFeatureName,
  {
    [ReportsComponentsNamespace]: ReportsComponentsReducer,
    [ReportsDashboardsNamespace]: ReportsDashboardsReducer,
    [ReportsMetricsNamespace]: ReportsMetricsReducer,
    [ReportsResultsNamespace]: ReportsResultsReducer,
  },
  {
    metaReducers: [referenceReducer],
  },
);

const reportsEffects = provideEffects([
  ReportsComponentsEffects,
  ReportsDashboardsEffects,
  ReportsMetricsEffects,
  ReportsResultsEffects,
]);

export const provideCoreReportsData = (): Array<EnvironmentProviders | Provider> => [
  ReportsComponentsHttpClient,
  ReportsDashboardsHttpClient,
  ReportsMetricsHttpClient,
  ReportsResultsHttpClient,
  reportsState,
  reportsEffects,
];
